import { createAsyncThunk } from "@reduxjs/toolkit";
import { ExecuteAIQueryParams, ExecuteAIQueryResponse } from "../../types/aiStudioTypes";
import { getDataUserId } from "../../util/manageAuth";
import customFetch from "../../util/config/axiosConfig";


export const executeAIQuery = createAsyncThunk<
    ExecuteAIQueryResponse,
    ExecuteAIQueryParams,
    { rejectValue: string }
>(
    "ai/executeQuery",
    async (params, thunkAPI) => {
        try {
            const userId = getDataUserId();

            if (!userId) {
                throw new Error("User not authenticated");
            }

            const response = await customFetch.post(
                "/api/ai/execute",
                {
                    userId,
                    query: params.query.trim(),
                }
            );

            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.message || "Failed to execute AI query"
            );
        }
    }
);

export const executeAIChatQuery = createAsyncThunk<
    ExecuteAIQueryResponse,
    ExecuteAIQueryParams,
    { rejectValue: string }
>(
    "ai/executeChatQuery",
    async (params, thunkAPI) => {
        try {
            const userId = getDataUserId();

            if (!userId) {
                throw new Error("User not authenticated");
            }

            const response = await customFetch.post(
                "/api/chat/execute",
                {
                    userId,
                    query: params.query.trim(),
                }
            );

            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.message || "Failed to execute AI query"
            );
        }
    }
);